import React from 'react'

function FacilidadesDePagoScreen() {
  return (
    <div>FacilidadesDePagoScreen</div>
  )
}

export default FacilidadesDePagoScreen